import { primaryRelationshipColumn, roleColumn } from "./columnHelpers";
import { objectDefinition } from "./supportedObjects";

const {pluralName, color, endpoint} = objectDefinition('contact');

export const contactsRelationship = {
    collapsible: true,
    title: pluralName,
    tint: color,
    type: 'table',
    columns: [
        primaryRelationshipColumn({endpoint}),
        roleColumn,
    ],
};
